import {Component, input, output} from '@angular/core';

@Component({
  selector: 'app-numeric-stepper',
  templateUrl: './numeric-stepper.component.html',
  styleUrl: './numeric-stepper.component.css'
})
export class NumericStepperComponent {
  
  value = input.required<number>();
  incrementEnabled = input.required<boolean>();
  decrementEnabled = input.required<boolean>();
  change = output<number>();
  disabled = input(false);

  increment() {
    this.change.emit(this.value() + 1);
  }

  decrement() {
    this.change.emit(this.value() - 1);
  }
}
